import React, { useState, useEffect } from "react"
import { Row, Col, Input } from "reactstrap"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))
const generalService = new General(user)

const NewProjectLocation = ({
  appId,
  data = {},
  onChange,
  disableFormFields,
}) => {
  const [provinces, setProvinces] = useState([])
  const [districts, setDistricts] = useState([])
  const [sectors, setSectors] = useState([])
  const [cells, setCells] = useState([])

  const [selectedProvince, setSelectedProvince] = useState(
    data.province_id || ""
  )
  const [selectedDistrict, setSelectedDistrict] = useState(
    data.district_id || ""
  )
  const [selectedSector, setSelectedSector] = useState(data.sector_id || "")
  const [selectedCell, setSelectedCell] = useState(data.cell_id || "")

  const [selectedProvinceName, setSelectedProvinceName] = useState(
    data.province_id || ""
  )
  const [selectedDistrictName, setSelectedDistrictName] = useState(
    data.district_id || ""
  )
  const [selectedSectorName, setSelectedSectorName] = useState(
    data.sector_id || ""
  )
  const [selectedCellName, setSelectedCellName] = useState(data.cell_id || "")

  useEffect(() => {
    fetchProvinces()
  }, [])

  const fetchProvinces = async () => {
    const response = await generalService.getProvinces()
    if (response.status) {
      setProvinces(response.data)
    }
  }

  const fetchDistricts = async provinceId => {
    const response = await generalService.getDistricts(provinceId)
    if (response.status) {
      setDistricts(response.data)
    }
  }

  const fetchSectors = async districtId => {
    const response = await generalService.getSectors(districtId)
    if (response.status) {
      setSectors(response.data)
    }
  }

  const fetchCells = async sectorId => {
    const response = await generalService.getCells(sectorId)
    if (response.status) {
      setCells(response.data)
    }
  }

  const handleProvinceChange = e => {
    const provinceId = e.target.value
    const provinceName = provinces.find(p => p.id === provinceId)?.name || ""
    setSelectedProvince(provinceId)
    setSelectedDistrict("")
    setSelectedSector("")
    setSelectedCell("")
    setDistricts([])
    setSectors([])
    setCells([])
    if (provinceId) fetchDistricts(provinceId)
    console.log(provinces)
    const provinceObj = provinces.find(province => province.id == provinceId)
    onChange({
      ...data,
      application_id: appId,
      province_id: provinceId,
      province_name: provinceObj.name,
      district_id: "",
      district_name: "",
      sector_id: "",
      sector_name: "",
      cell_id: "",
      cell_name: "",
    })
  }

  const handleDistrictChange = e => {
    const districtId = e.target.value
    const districtName = districts.find(d => d.id === districtId)?.name || ""
    setSelectedDistrict(districtId)
    setSelectedSector("")
    setSelectedCell("")
    setSectors([])
    setCells([])
    if (districtId) fetchSectors(districtId)
    const districtObj = districts.find(district => district.id == districtId)

    onChange({
      ...data,
      district_id: districtId,
      district_name: districtObj.name,
      sector_id: "",
      sector_name: "",
      cell_id: "",
      cell_name: "",
    })
  }

  const handleSectorChange = e => {
    const sectorId = e.target.value
    const sectorName = sectors.find(s => s.id === sectorId)?.name || ""
    setSelectedSector(sectorId)
    setSelectedCell("")
    setCells([])
    if (sectorId) fetchCells(sectorId)
    const sectorObj = sectors.find(sector => sector.id == sectorId)
    onChange({
      ...data,
      sector_id: sectorId,
      sector_name: sectorObj.name,
      cell_id: "",
      cell_name: "",
    })
  }

  const handleCellChange = e => {
    const cellId = e.target.value
    const cellName = cells.find(c => c.id === cellId)?.name || ""
    setSelectedCell(cellId)
    const cellObj = cells.find(cell => cell.id == cellId)
    onChange({ ...data, cell_id: cellId, cell_name: cellObj.name })
  }

  return (
    <Row>
      <Col md="3">
        {disableFormFields ? (
          <Input type="text" value={data.province.name} disabled />
        ) : (
          <Input
            type="select"
            value={selectedProvince}
            onChange={handleProvinceChange}
            required
          >
            <option value="">-- Select Province --</option>
            {provinces.map(province => (
              <option key={province.id} value={province.id}>
                {province.name}
              </option>
            ))}
          </Input>
        )}
      </Col>
      <Col md="3">
        {disableFormFields ? (
          <Input type="text" value={data.district.name} disabled />
        ) : (
          <Input
            type="select"
            value={selectedDistrict}
            onChange={handleDistrictChange}
            disabled={!selectedProvince}
            required
          >
            <option value="">-- Select District --</option>
            {districts.map(district => (
              <option key={district.id} value={district.id}>
                {district.name}
              </option>
            ))}
          </Input>
        )}
      </Col>
      <Col md="3">
      {disableFormFields ? <Input type="text" value={data.sector.name} disabled /> :  <Input
          type="select"
          value={selectedSector}
          onChange={handleSectorChange}
          disabled={!selectedDistrict}
          required
        >
          <option value="">-- Select Sector --</option>
          {sectors.map(sector => (
            <option key={sector.id} value={sector.id}>
              {sector.name}
            </option>
          ))}
        </Input>}
       
      </Col>
      <Col md="3">
      {disableFormFields ? <Input type="text" value={data.cell.name} disabled /> : <Input
          type="select"
          value={selectedCell}
          onChange={handleCellChange}
          disabled={!selectedSector}
          required
        >
          <option value="">-- Select Cell --</option>
          {cells.map(cell => (
            <option key={cell.id} value={cell.id}>
              {cell.name}
            </option>
          ))}
        </Input>}
        
      </Col>
    </Row>
  )
}

export default NewProjectLocation
